import { z } from 'zod'

export const walletSchema = z.looseObject({
  balance: z.number(),
  lots: z.object({
    paid: z.number(),
    bonus: z.number(),
    attendance: z.number(),
  }),
  charged: z.boolean(),
  freeTurns: z.number(),
  unlockTickets: z.number(),
  totalTurns: z.number(),
  nextTicketIn: z.number(),
  entries: z.array(
    z.looseObject({
      id: z.string(),
      amount: z.number(),
      reason: z.string(),
      kind: z.string(),
      expiresAt: z.string().nullable(),
      createdAt: z.string(),
    })
  ),
  ticketEntries: z.array(
    z.looseObject({
      id: z.string(),
      kind: z.string(),
      amount: z.number(),
      reason: z.string(),
      createdAt: z.string(),
    })
  ),
})

export type Wallet = z.infer<typeof walletSchema>
